/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolUsageUserSummary,
  ToolUsageUserSummary$inboundSchema,
} from "./toolusageusersummary.js";

/**
 * Top MCP and tool usage user identities for the selected filters and time range
 */
export type GetToolUsageUsersResult = {
  /**
   * Top user identities for the selected filters and time range
   */
  users: Array<ToolUsageUserSummary>;
};

/** @internal */
export const GetToolUsageUsersResult$inboundSchema: z.ZodMiniType<
  GetToolUsageUsersResult,
  unknown
> = z.object({
  users: z.array(ToolUsageUserSummary$inboundSchema),
});

export function getToolUsageUsersResultFromJSON(
  jsonString: string,
): SafeParseResult<GetToolUsageUsersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetToolUsageUsersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetToolUsageUsersResult' from JSON`,
  );
}
